import { render, staticRenderFns } from "./addOweFeeCallableList.vue?vue&type=template&id=56207864&scoped=true"
import script from "./addOweFeeCallableList.vue?vue&type=script&lang=js"
export * from "./addOweFeeCallableList.vue?vue&type=script&lang=js"
import style0 from "./addOweFeeCallableList.vue?vue&type=style&index=0&id=56207864&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_29ccf6a1548590c1291b44f0faebdb79/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56207864",
  null
  
)

export default component.exports